<template>
  <basic-dialog
    :width="1000"
    :visible="visible"
    :ok-text="okText"
    :close-text="closeText"
    :title="title"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
  >
    <basic-list
      :tableH="500"
      :fields="fields"
      :list="list"
      :index-col-label="indexColLabel"
      :show-action-col="showActionCol"
      :show-index-col="showIndexCol"
      :show-head="showHead"
    />
  </basic-dialog>
</template>

<script>
import EntityDialog from "@/mixins/entityDialog";
import BasicList from "@/components/basicList";
import { mapState } from "vuex";
export default {
  components: {
    BasicList,
  },
  mixins: [EntityDialog],
  props: {
    visible: Boolean,
    winClose: Function,
    dispatch: Function,
  },
  data() {
    return {
      okText: this.$t('language.5o6u3frcn9k0'),
      closeText: this.$t('language.5o6u3frcn8k0'),
      indexColLabel: this.$t('language.5o6v4bolfsc0'),
      showActionCol: false,
      showIndexCol: false,
      showHead: false,
      fields: [
        { key: "extNo", name: this.$t('language.5o6v4bolfsc0'), width: 80 },
        {
          key: "isEffective",
          name: this.$t('language.5o6v4bolfv40'),
          width: 80,
          render: (h, { row }) => (
            <el-checkbox
              v-model={row.isEffective}
              true-label={1}
              false-label={0}
            />
          ),
        },
        {
          key: "isRequired",
          name: this.$t('language.5o6v4bolfxo0'),
          width: 80,
          render: (h, { row }) => (
            <el-checkbox
              v-model={row.isRequired}
              true-label={1}
              false-label={0}
            />
          ),
        },
        {
          key: "extName",
          name: this.$t('language.5o6v4bolg0c0'),
          render: (h, { row }) => (
            <el-input v-model_trim={row.extName} size="small" />
          ),
        },
        {
          key: "isEnum",
          name: this.$t('language.5o6v4bolg340'),
          width: 120,
          render: (h, { row }) => (
            <el-checkbox v-model={row.isEnum} true-label={1} false-label={0} />
          ),
        },
        {
          key: "enumValue",
          name: this.$t('language.5o6v4bolg5s0'),
          minWidth: 160,
          render: (h, { row }) => (
            <el-input
              v-model_trim={row.enumValue}
              placeholder={this.$t('language.5o6vkto5z640')}
              size="small"
            />
          ),
        },
      ],
      list: this.getDefaultList(),
    };
  },
  computed: {
    ...mapState("app", ["tenementCode"]),
    title() {
      return this.$t('language.5o6u3frcno10');
    },
  },
  watch: {
    visible(nVis) {
      if (nVis) {
        this.queryExtendList();
      }
    },
  },

  methods: {
    getDefaultList() {
      const listLen = Array(10).fill(0);
      const list = listLen.map((item, index) => {
        const extNo = index + 1;
        const row = {
          id: null,
          extNo,
          extCode: `ext_${extNo}`,
          isEffective: 0,
          isRequired: 0,
          extName: "",
          isEnum: 0,
          enumValue: "",
          tenementCode: this.tenementCode,
        };
        return row;
      });
      return list;
    },
    handleOk() {
      const pass = this.checkParams();
      if (!pass) return;
      this.saveHandler();
    },
    async saveHandler() {
      let ajaxMethod = () => {};
      const list = _.cloneDeep(this.list);
      const args = {
        appCode: sessionStorage.getItem("appCode"),
        data: JSON.stringify(list),
      };
      console.log("========dialog 位置4=====params:appCode:", this.appCode);
      const { code, msg } = await api.rolePermissions.extRoleAddOrEdit({
        data: args,
      });
      if (code === 200) {
        this.$message.success(msg);
        this.handleClose();
        this.$emit("SETLISTEXTENDFIELDS", list);
        this.dispatch("queryRoleExtList");
      } else {
        this.$message.error(msg);
      }
    },
    // 入参校验
    checkParams() {
      for (let i = 0, list = this.list, len = list.length; i < len; i++) {
        const row = list[i];
        const nextRow = i !== len - 1 ? list[i + 1] : {};
        if (
          row.isEffective === 0 &&
          nextRow.isEffective === 1 &&
          i !== len - 1
        ) {
          this.$message.error(this.$t('language.5o6vkto600s0'));
          return;
        }
        // 將null&undefined轉為字符串
        row.enumValue =
          typeof row.enumValue === "string" ? row.enumValue.trim() : "";
        row.extName =
          typeof row.extName === "string" ? row.extName.trim() : row.extName;
        if (row.isEffective === 1 && _.isEmpty(row.extName)) {
          this.$message.error(this.$t('language.5o6vkto602w0'));
          return;
        }
        if (typeof row.extName === "string" && row.extName.length > 10) {
          this.$message.error(
            `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm44hb0')}`
          );
          return;
        }
        if (
          row.isEffective === 1 &&
          !CNST.REG_EXP.ENGNUMLINEZH.test(row.extName)
        ) {
          this.$message.error(
            `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm44hl0')}`
          );
          return;
        }
        if (typeof row.enumValue === "string" && row.enumValue.length > 200) {
          this.$message.error(
            `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqm14hko')}`
          );
          return;
        }
        if (row.isEnum === 1 && _.isEmpty(row.enumValue.trim())) {
          this.$message.error(this.$t('language.5o6vkto604k0'));
          return;
        }
        // 不允许最后一个字符为逗号
        if (
          row.isEnum === 1 &&
          row.enumValue.length &&
          row.enumValue[row.enumValue.length - 1] === ","
        ) {
          this.$message.error(
            `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm44hk0')}`
          );
          return;
        }
        if (row.isEnum === 1 && !_.isEmpty(row.enumValue)) {
          const enumStr = row.enumValue;
          if (enumStr.includes(",")) {
            const keys = [];
            const values = [];
            const array = enumStr.split(",");
            for (let j = 0; j < array.length; j++) {
              if (!CNST.REG_EXP.ENUM_VALUE_STR.test(array[j])) {
                this.$message.error(
                  `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqmi4hk0')}`
                );
                return;
              }
              const itemInfo = array[j].split(":");
              const itemKey = itemInfo[0].trim();
              const itemValue = itemInfo[1].trim();
              if (!itemKey || !itemValue) {
                this.$message.error(`${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uh9m44hk0')}`);
                return;
              }
              if (keys.includes(itemKey)) {
                this.$message.error(
                  `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm44hl0')}${itemKey}${this.$t('language.5o6uhqm4yhk0')}`
                );
                return;
              } else {
                keys.push(itemKey);
              }
              if (values.includes(itemValue)) {
                this.$message.error(
                  `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6uhqm4phl0')}${itemValue}${this.$t('language.5o6uhqm4yhk0')}`
                );
                return;
              } else {
                values.push(itemValue);
              }
            }
          } else if (!CNST.REG_EXP.ENUM_VALUE_STR.test(enumStr)) {
            this.$message.error(
              `${this.$t('language.5o6v4bolfsc0')}${row.extNo}${this.$t('language.5o6ukqmi4hk0')}`
            );
            return;
          }
        }
      }
      return true;
    },
    async queryExtendList() {
      this.list = this.getDefaultList();
      const params = {
        data: {
          tenementCode: this.tenementCode,
          appCode: sessionStorage.getItem("appCode"),
        },
      };
      console.log(
        "=======queryExtendList= 位置5=======" +
          sessionStorage.getItem("appCode")
      );
      console.log("========queryExtendList========params:appCode", this.state);
      const { code, msg, data } = await api.rolePermissions.queryRoleExtList(
        params
      );
      if (code === 200) {
        if (data.length === 0) return;
        this.toFont(data || []);
      } else {
        this.$message.error(msg);
      }
    },
    toFont(data) {
      data = data.map((item) => _.omit(item, ["extNo"]));
      data.forEach((item, index) => {
        Object.assign(this.list[index], item);
      });
    },
    handleClose() {
      this.winClose();
    },
  },
};
</script>
